export default "/images/vendor/@coreui/icons/svg/flag/cif-me.svg?a516c6cae50f523462c45715aa799ed0";